import { Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import StaticEditorContent from "components/ui/atoms/Editor/StaticEditorContent";
import { CompanyTag, PersonTag } from "components/ui/atoms/Tag";
import CompanyDealsAndSourcings from "models/companies/CompanyDealsAndSourcings";
import NoteFormHeader from "models/notes/NoteFormHeader";

const NoteView = ({ note, onCancel, hideHeader = false }) => {
  return (
    <>
      {!hideHeader && (
        <NoteFormHeader formType="update" onClose={onCancel} note={note} />
      )}
      <Stack spacing={2} padding={2} pt={"80px"}>
        <Stack
          direction="row"
          justifyContent="flex-start"
          flexWrap="wrap"
          spacing={1}
        >
          {note?.companies_detail.map((company, index) => {
            return (
              <Link
                to={`/company/${company.id}`}
                key={`company_link_${index}`}
                target="_blank"
              >
                <CompanyTag company={company} style={{ cursor: "pointer" }} />
              </Link>
            );
          })}
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-start"
          flexWrap="wrap"
          my={1}
          sx={{ gap: 1 }}
        >
          {note?.people.map((person, index) => {
            return (
              <Link
                to={`/people/${person.id}/`}
                key={`people_link_${index}`}
                target="_blank"
              >
                <PersonTag person={person} style={{ cursor: "pointer" }} />
              </Link>
            );
          })}
        </Stack>
        <Grid size={12}>
          <StaticEditorContent html={note?.content} />
        </Grid>
        <Grid size={12} sx={{ width: "100%", boxSizing: "border-box" }}>
          <CompanyDealsAndSourcings
            companyIds={note.companies_ids}
            onlyActiveDealsAndSourcings
            widgetMode
          />
        </Grid>
      </Stack>
    </>
  );
};

export default NoteView;
